import $ from 'jquery';

export const outerHeight = (element) => $(element).outerHeight(true);
export const outerWidth = (element) => $(element).outerWidth(true);

export const isPositionWithin = (clientX, clientY, element) => {
  const elementPos = element.getBoundingClientRect();
  return clientY > elementPos.top && clientY < elementPos.bottom && clientX > elementPos.left && clientX < elementPos.right;
};

export const disableElements = (isDisabled, ...elements) => {
  if (isDisabled) {
    elements.forEach(el => el.setAttribute('disabled', true));
  } else {
    elements.forEach(el => el.removeAttribute('disabled'));
  }
};
